import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { AsyncPaginate } from 'react-select-async-paginate';
import { fetchInterpreters } from 'slices/interpreterSlice';
import { interpreterSelector } from 'slices/interpreterSlice';
import { selectCustomStyles } from './Select';
import ErrorMessage from './ErrorMessage';
import { SubmitButton } from './buttons/SubmitButton';

const SelectInterperter = ({ setInterpreter, appointment_language, filters, gender }) => {
    const { control, errors, register, handleSubmit } = useForm();
    const dispatch = useDispatch();
    const { interpreter: interpreters, loader: loaderInterpreter } = useSelector(interpreterSelector);

    const [interpreterState, setInterpreterState] = useState([])

    const rawGender = gender || filters?.gender || filters?.interpreter_gender || "";
    const normalizedGender = typeof rawGender === 'string' ? rawGender.trim().toLowerCase() : "";
    const activeGender = Boolean(normalizedGender && !['no_preference', 'all', 'null', 'undefined'].includes(normalizedGender) && ['male', 'female'].includes(normalizedGender))
        ? normalizedGender
        : undefined;

    const filteredInterpretersLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchInterpreters(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue, appointment_interpreter: true, appointment_language: appointment_language, service_type: "interpreter" , filters: filters }, true, true));
        const cleanFilters = { ...filters };
        delete cleanFilters.gender;
        delete cleanFilters.interpreter_gender;

        // const result = await dispatch(fetchInterpreters(page, { 
        //     pageLength: 20, 
        //     sortBy: "id", 
        //     sortDirection: "asc", 
        //     search: inputValue, 
        //     appointment_interpreter: true, 
        //     appointment_language: appointment_language, 
        //     service_type: "interpreter",
        //     exclude_interpreter: exclude_interpreter ? 1 : 0,
        //     call_target_vendor: call_target_vendor,
        //     vendor_type: call_target_vendor,
        //     gender: activeGender,
        //     interpreter_gender: activeGender,
        //     filters: cleanFilters 
        // }, true, true));
        return {
            options: result?.data?.map(item => ({
                value: item?.id,
                label: item?.first_name + " " + item?.last_name,
            })),
            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion


    const onSubmit = (data) => {
        console.log(data);
    }




    return (
        <div>
            <div className="row-primary" style={{display: "flex", flexDirection: "column"}}>
                <h2>Select Vendor</h2>
                <Controller
                    name="interpreter_id"
                    control={control}
                    rules={{
                        required: "Please select a Vendor"
                    }}
                    render={({ field }) =>
                        <div style={{ width: "100%", height: "64px" }}>
                            <AsyncPaginate
                                // menuPlacement='top'
                                styles={{
                                    ...selectCustomStyles,
                                    menuList: (def) => ({ 
                                        ...def, 
                                        height: 150

                                    }),
                                }}
                                isMulti
                                value={interpreterState}
                                loadOptions={filteredInterpretersLoadOptions}
                                isClearable
                                escapeClearsValue
                                onChange={(obj) => {
                                    setInterpreterState(obj);
                                    field.onChange(obj);
                                    setInterpreter({ interpreter_id: obj })
                                }}
                                additional={{
                                    page: 1,
                                }}

                            />
                            {errors?.interpreter_id?.message &&
                                <div style={{ marginBottom: 10 }}>
                                    <ErrorMessage text={errors?.interpreter_id?.message} />
                                </div>
                            }
                        </div>
                    }
                />
            </div>

            {/* <SubmitButton btnText="Submit" handleSubmit={handleSubmit(onSubmit)} /> */}
        </div>
    )
}

export default SelectInterperter